import _BaseApiService from "../_BaseAPIService";

const apiService = _BaseApiService.instance;

const SystemDataService = {
  create: async (data) => {
    const response = await apiService.post("/systemdata", data);
    return response.data;
  },
  getList: async () => {
    const response = await apiService.get("/systemdata");
    return response.data;
  },
  getDetail: async (id) => {
    const response = await apiService.get(`/systemdata/${id}`);
    return response.data;
  },
  update: async (id, updatedData) => {
    try {
      const response = await apiService.put(`/systemdata/${id}`, updatedData);
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },
   delete:async (id) => {
        const response = await apiService.delete(`/systemdata/${id}`);
        return response.data;
    },
};
export default SystemDataService;
